module.exports = __webpack_public_path__ + "img/thumbnail-velaine-video.ee66cfd.jpg";